const loadingFlavorText = [
  "Digging through side pouches...",
  "Rummaging past crumpled maps...",
  "Shaking out some mysterious lint...",
  "Jostling everything loose with a good shake...",
  "Wiggling fingers past something... damp?",
  "Tugging at tangled straps and snacks...",
  "Brushing past a bundle of pocket fuzz...",
  "Unsnapping buckles with chaotic confidence...",
  "Sifting through layers of questionable gear...",
  "Peeking past socks, snacks, and secrets...",
  "Thumbing through trinkets and trouble...",
  "Flipping flaps and unrolling scrolls...",
  "Poking into every suspicious fold...",
  "Checking the secret pouch (don’t worry about it)...",
  "Scooting aside some crinkly paper and mystery goo...",
  "Tickling the zipper until it gives up a treasure...",
  "Swooshing past half a granola bar and a dream...",
  "Prodding something that may have just blinked...",
  "Hoping for gold, expecting glitter...",
  "Reaching deep into inventory chaos..."
];

export default loadingFlavorText;
